module.exports = __webpack_public_path__ + "img/logo-um-pef-ang.1e1db031.png";